import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ProductVariantDto
*  Информация о текущем продукте в виде варианта<br>
*/
export class ProductVariantDto extends ActiveModel {

  /**
  * id
  * Идентификатор варианта<br>  */
  @ActiveField(0)
  id: number = 0


  /**
  * keyVector
  * Вектор варианта, где: <br><br>ключ: идентификатор ключевого атрибута; <br><br>значение: значение ключевого атрибута для варианта<br>  */
  @ActiveField(() => ({}))
  keyVector: Record<string, object> = {}
}
